<template>
    <div class="box">
        <img class="img" :src="require('@/assets/WelfareFebruary5.png')" alt="">
        <div class="text1">警告</div>
        <div class="text2">
            由于平台搜索权重较低，店铺<span>曝光度持续下降</span>商品曝光远远低于同行！
        </div>
        <div class="text3">
            提高旺旺响应率至<span>80%以上</span>
        </div>
        <div class="text3">一个月有效提高店铺曝光</div>
        <div class="text3">三个月持续提升平台流量</div>
        <div @click="show_popup" class="button">立即提升</div>

        <Popup v-model="popup_show"
        position="top"
        overlay-class="popup_box"
        :close-on-click-overlay="false"
        :lock-scroll="true"
        :lazy-render="false">
            <img class="WXTExtension_popup" :src="popup_img">
        </Popup>
    </div>
</template>
<script>
import { Popup } from 'vant';
export default {
    components:{
        Popup,
    },
    data(){
        let popup_img
        if(this.$config.SystemOS=='IOS'){
            popup_img = this.$OSSBaseUrl +'renew_tips_ios.png';
        }else{
            popup_img = this.$OSSBaseUrl + 'renew_tips_android.png';
        }
        return{
            popup_img,
            popup_show:false,
            record_data:{
                page_from:'main_page',
                page_name:'WelfareFebruary/Warning',
                page_time:'0.00',
                receiver_id: '',
                page_param:{dayhour:this.$route.query.dayhour,},
            },
        }
    },
    mounted(){
        this.$store.dispatch('Public/inH5Record', this.record_data)
    },
    methods:{
        show_popup(){
            let data = JSON.parse(JSON.stringify(this.record_data))
            data.btn_name = 'WelfareFebruary/Warning'
            this.$store.dispatch('Public/inH5Record', data)
            this.popup_show = true
        }
    },
}
</script>
<style lang="scss" scoped>
    @import 'Warning.scss';
</style>